<template>
  <div class="goods">
    <v-head :title="title"></v-head>

      <div v-if="showBotton" class="warmTips">
        <div>
            <img src="../../assets/images/empty-image-default.png"/>
            <p>还没有需要支付的订单，请您点击缴纳会费按钮，生成订单并缴纳会费</p>
        </div>
        <div style="text-align:center;" @click="payShow">
           <van-button type="danger">缴纳会费</van-button>
        </div>
      </div>
    <!-- <span class="Payment" @click="payShow" v-if="showBotton">缴纳会费</span> -->
    <!-- <span class="Payment" @click="show = true" v-if="showBotton">缴纳会费</span> -->
    <div class="content">
      <div class="fontsBox">
        <payWords></payWords>
      </div>
      <div class="order-list">
        <template v-for="item in orderList.content">
          <v-order
            :item="item"
            :key="item.title"
            :isWXPay="isWXPay"
            from="member"
            @onLine="onLine"
            @getDate="refreshData"
          ></v-order>
        </template>
      </div>
    </div>
    <!-- 弹窗 -->
    <van-action-sheet
      v-model="show"
      :actions="options"
      @select="choiceOfYears"
      title="请选择缴费年限"
    >
      <template>
        <!--<div class="inpbox">
          <el-select v-model="value" placeholder="请选择" @change="choiceOfYears">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
          </div>
           <div class="inpbox inpcox">
           <el-input v-model="params.amount" placeholder="请输入内容" class="" :disabled="true"></el-input>
          </div>
          <el-button type="primary" @click="create">提交</el-button>-->
      </template>
    </van-action-sheet>
  </div>
</template>
<script>
import {
  baseURL,
  getPaymentList,
  createOrder,
  getWXCode,
  getWebsocket,
  SockJSURL,
  getWXPay,
  isShowPayBtn,
  getUser,
  getDuesList,
  memberAudit,
  getAuthurl,
  getGroupDues,
  getDictionaryByCode,
} from "@/api/dictionary";
import vHead from "../../components/Subhead.vue";
import vOrder from "../../components/order.vue";
import { getSessionStore } from "@/utils/sessionStorage.js";
import {
  Uploader,
  Toast,
  Button,
  ImagePreview,
  ActionSheet,
  Dialog,
} from "vant";
import { mapGetters, mapState, mapMutations } from "vuex";
import payWords from "wordsPath/payWords.vue";

export default {
  data() {
    return {
      show: false,
      fileList: [],
      photoList: [],
      memberDues: [],
      pay: false,
      loading: true,
      value: "",
      size: 300,
      codeUrl: null,
      baseURL: baseURL,
      dialogOnline: false,
      socket: null,
      isSelect: false,
      refresh: false,
      isShowPay: false,
      page: 1,
      orderTip: "",
      payStatus: 0,
      memberInfo: {},
      title: "缴费列表",
      isWXPay: true,
      orderList: {
        content: [],
      },
      mode: 1,
      message: {
        id: "",
        name: "111",
      },
      list: {
        content: [],
      },
      params: {
        amount: null,
        price: null,
      },
      options: [
        //   {
        //   value: '1',
        //   name: '一年'
        // }, {
        //   value: '2',
        // name: '两年'
        // }, {
        //   value: '3',
        // name: '三年'
        // }, {
        //   value: '4',
        // name: '四年'
        // }, {
        //     value: '5',
        //     name: '五年'
        // }
      ],
      showBotton: false,
    };
  },
  components: {
    vHead,
    vOrder,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
    [ActionSheet.name]: ActionSheet,
    [Dialog.Component.name]: Dialog.Component,
    payWords,
  },
  computed: {
    ...mapGetters(["isGroupMember"]),
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapMutations(["setMemberInfo"]),
    go(pathName) {
      this.$router.push({ name: pathName });
    },
    payShow(){
       this.$router.push({ name: 'paymentPage' });
    },
    choiceOfYears(data) {
      this.params.amount = this.params.price * data.value;
      this.params.years = data.value;
      Dialog.confirm({
        title: "标题",
        message:
          "缴费年数" +
          data.value +
          "年" +
          "缴费金额" +
          this.params.amount +
          "元",
      })
        .then(() => {
          this.create();
          Toast.success("订单生成");
          this.show = false;
        })
        .catch(() => {
          Toast.fail("缴费取消");
        });
    },
    getDate: function() {
      const token = getSessionStore("access_token");
      this.loading = true;
      let orderTypeList = [1, 3, 4, 5, 6];
      getPaymentList(
        { orderTypeList: orderTypeList, access_token: token },
        this.page - 1
      )
        .then((res) => {
          if (res.success) {
            this.orderList = res.result;
          }
        })
        .catch(() => {
          Toast.fail("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changePage: function(val) {
      this.page = val;
      this.getDate();
    },
    useqrcode() {
      let qrcode = new QRCode("qrcode", {
        width: 100,
        height: 100, // 高度
        text: "56663159", // 二维码内容
        image: "", // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas） // background: '#f0f' // foreground: '#ff0'
      });
    },
    selectPay(type) {
      if (type == 1) {
        Toast.fail("暂不支持支付宝支付！");
        return;
      }
    },
    onLine(item) {
      this.dialogOnline = true;
      //this.$router.push({ name: 'onlinePayment'});
      getAuthurl({ orderNo: item.orderNo }).then((res) => {
        if (res.success) {
          let url = res.result;

          window.location = url;
        }
      });

      //this.getWXPay(item);
    },
    infoWS() {
      var _this = this,
        stompClient;
      this.socket = new SockJS(SockJSURL);

      stompClient = Stomp.over(this.socket);
      stompClient.connect({}, function(frame) {
        stompClient.subscribe(
          "/pay/callback",
          function(msg) {
            _this.dialogOnline = false;
            _this.getDate();
            Toast.success("支付成功");
            stompClient.disconnect();
          },
          function(err) {
            console.log(error.headers.message);
          }
        );
      });
    },
    create() {
      // setTimeout(function(){this.$router.push({path:"invoiceMessage"})},3000);
      getUser().then((res) => {
        if (9 == res.result.memberCategory) {
          Toast.fail("请先申请成为会员再缴纳会费!");
          return;
        } else {
          const token = getSessionStore("access_token");
          this.params.access_token = token;
          createOrder(this.params).then((res) => {
            if (res.success) {
              Toast.success("添加订单成功！");
              this.getDate();
              this.getPayBtnStatus();
              this.pay = false;
              if (this.params.amount == "0") {
                var params = {
                  amount: "0",
                  result: 1,
                  reason: "",
                  orderId: res.result.id,
                  memberCategory: 1,
                };

                memberAudit(params).then((res) => {
                  console.log(res);
                  Toast.fail("会费已缴纳！");
                  this.getDate();
                });
              }
            } else {
              Toast.fail("创建订单失败！");
            }
          });
        }
      });
    },

    goMemberPay() {
      this.$router.push({ name: "memberPay", query: { orderType: 1 } });
    },
    getOrderMessage: function() {
      getOrderMessage().then((data) => {
        this.orderTip = data;
      });
    },

    goPay: function(obj) {
      this.$router.push({
        name: "memberPay",
        query: {
          payId: obj.id,
          price: obj.price,
          number: obj.number,
          orderType: obj.orderType,
          memberCount: obj.memberCount,
          memberFileId: obj.memberFileId,
          orderAmount: obj.orderAmount,
        },
      });
    },
    onBridgeReady(data) {
      // WeixinJSBridge.invoke(
      //     'getBrandWCPayRequest', {
      //       "appId":data.appid,     //公众号名称，由商户传入
      //       "timeStamp":data.timeStamp,         //时间戳，自1970年以来的秒数
      //       "nonceStr":data.nonceStr, //随机串
      //       "package":"prepay_id=" + data.prepayId,
      //       "signType":"MD5",         //微信签名方式：
      //       "paySign":data.sign //微信签名
      //     },
      //     function(res){
      //     if(res.err_msg == "get_brand_wcpay_request:ok" ){
      //         // 使用以上方式判断前端返回,微信团队郑重提示：
      //           //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
      //               alert(JSON.stringify(res));
      //     }else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
      //     }else{
      //         alert(JSON.stringify(res));
      //     }
      // });
    },
    getWXPay(order) {
      let params = {
        orderNo: order.orderNo,
        totalFee: order.amount,
      };

      this.loading = true;
      getWXCode(params)
        .then((res) => {
          this.onBridgeReady(res);

          if (res.codeUrl) {
            this.codeUrl = res.codeUrl;
            //this.infoWS();
          } else {
            this.dialogOnline = false;
            Toast.fail("订单已支付");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getIsWXPay() {
      getWXPay().then((res) => {
        this.isWXPay = res.result;
      });
    },
    getPayBtnStatus() {
      const token = getSessionStore("access_token");
      isShowPayBtn({ access_token: token }).then((res) => {
        this.isShowPay = res.result;
        if (this.isShowPay) {
          if (
            this.userInfo.memberStatus == 5 ||
            this.userInfo.memberStatus == 8
          ) {
            if (!this.userInfo.expiryDate || this.payMember) {
              this.showBotton = true;
            }
          } else if (this.userInfo.memberStatus == 1 && this.payMember) {
            this.showBotton = true;
          } else {
            this.showBotton = false;
          }
        }
      });
    },
    getMemberDues() {
      if (this.memberInfo.memberCategory == 1) {
        getDuesList().then((res) => {
          if (res.success) {
            this.memberDues = res.result;
            const dues = this.memberDues.filter((item) => {
              return item.memberType === this.memberInfo.memberType;
            });
            this.params.price = dues[0].amount;
          }
        });
      } else {
        getGroupDues().then((res) => {
          if (res.success) {
            this.groupDues = res.result;
            const dues = this.groupDues.filter((item) => {
              return item.memberType === this.memberInfo.memberType;
            });
            this.params.price = dues[0].amount;
          }
        });
      }
    },
    getWxBridge() {
      // if (typeof WeixinJSBridge == "undefined"){
      //   if( document.addEventListener ){
      //       document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
      //   }else if (document.attachEvent){
      //       document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      //       document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
      //   }
      // }
    },
    refreshData() {
      this.getDate();
      this.getPayBtnStatus();
      this.isGroupMember;
    },
  },
  watch: {
    userInfo(val) {
      let expDate = new Date(this.userInfo.expiryDate);
      let curDate = new Date();
      expDate.setMonth(expDate.getMonth() - 1);
      if (this.userInfo.expiryDate != null && expDate <= curDate) {
        this.payMember = true;
      }
    },
  },
  mounted() {
    getUser().then((res) => {
      this.memberInfo = res.result;
      this.setMemberInfo(res.result);
    });
    //this.getOrderMessage();
    this.getIsWXPay();
    this.getDate();
    this.getPayBtnStatus();
    setTimeout(this.getMemberDues, 1000);
    this.getWxBridge();
    getDictionaryByCode("ORDER_YEARS").then((res) => {
      if (res.success) {
        this.options = res.result;
      }
    });
    let expDate = new Date(this.userInfo.expiryDate);
    let curDate = new Date();
    expDate.setMonth(expDate.getMonth() - 1);
    if (this.userInfo.expiryDate && expDate <= curDate) {
      this.payMember = true;
    }
  },
};
</script>

<style lang="less" scoped>
.Payment {
  position: absolute;
  z-index: 1000;
  right: 20px;
  top: 24px;
  color: rgb(32, 160, 255);
}

.fontsBox {
  width: 84%;
  margin: 20px auto 0 auto;
  background: #edf6fa;
  padding: 14px;
  font-size: 13px;
  border: #138cca dashed 1px;
  line-height: 22px;
  color: #69818e;
}
.warmTips{
  font-size: 15px;
  text-align: center;
  line-height: 25px;
  margin: 5% 0 12% 0;
  padding:0 30px
}
.warmTips img {
  width: 50%;
  display: block;
  margin: 0 auto;
  margin-bottom:10px;
}
.warmTips p{ margin-bottom:15px}
</style>
